var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamifySelfLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.904,
    height: 188.044,
    viewBox: "0 0 269.904 188.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.01 -24.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3,484.53c4.271,18.254,13.312,34.033,27.6,41.692,29.7,15.895,96.664,7.7,146.642-1.722a114.447,114.447,0,0,0,65.081-37.2Z",
    transform: "translate(-48.372 -354.053)",
    fill: "#285caa",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.548,74.414H319.125a2.369,2.369,0,1,1,0-4.738h4.741a2.372,2.372,0,0,1,0-4.741H320.48a2.372,2.372,0,0,1,0-4.741h14.313a37.871,37.871,0,0,0-11.167-3.078c-39.028-5.011-52.962-1.7-57.877,1.722a54.655,54.655,0,0,1-20.06,8.793c-24.08,4.967-69.113,10.945-109.929-1.914-20.286-6.4-35.362,4.409-44.4,22.456H351.309a42.356,42.356,0,0,0-3.22-14.328A2.352,2.352,0,0,1,346.548,74.414Z",
    transform: "translate(-69.529 -29.857)",
    fill: "#285caa",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.031,329.66a120.819,120.819,0,0,0,1.063,31.846l240.769,8.807A113.125,113.125,0,0,0,310.592,344.8Zm95.227,22.717h-4.741a2.369,2.369,0,1,1,0,4.738H115.094a2.369,2.369,0,1,1,0-4.738h4.741a2.372,2.372,0,0,1,0-4.741H116.45a2.371,2.371,0,0,1,0-4.741h27.423a2.371,2.371,0,0,1,0,4.741h3.385a2.372,2.372,0,0,1,0,4.741Z",
    transform: "translate(-39.431 -237.281)",
    fill: "#285caa",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.152,191.84l-262.861,6.4A104.876,104.876,0,0,0,54,225.379H318.547a112.448,112.448,0,0,0,3.821-17.3A81.984,81.984,0,0,0,323.152,191.84ZM107.365,212.79h-4.741a2.369,2.369,0,0,1,0,4.738H75.2a2.369,2.369,0,0,1,0-4.738h4.741a2.372,2.372,0,0,1,0-4.741H76.557a2.372,2.372,0,0,1,0-4.741H103.98a2.372,2.372,0,0,1,0,4.741h3.385a2.372,2.372,0,0,1,0,4.741Z",
    transform: "translate(-41.36 -133.367)",
    fill: "#285caa",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.506,
    cy: 5.981,
    rx: 110.506,
    ry: 5.981,
    transform: "translate(49.645 200.782)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.32,687.74s1.739,2.278-.8,5.7-4.641,6.336-3.8,8.481c0,0,3.836-6.383,6.969-6.472S897.754,691.579,894.32,687.74Z",
    transform: "translate(-642.431 -524.957)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.548,687.74a2.942,2.942,0,0,1,.355.713c3.048,3.583,4.669,6.925,1.743,7.008-2.731.079-6,4.958-6.786,6.19a2.4,2.4,0,0,0,.092.282s3.836-6.384,6.969-6.472S897.983,691.579,894.548,687.74Z",
    transform: "translate(-642.659 -524.957)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914,695.793c0,.8-.089,1.451-.2,1.451s-.2-.65-.2-1.451.114-.424.225-.424S914,694.992,914,695.793Z",
    transform: "translate(-658.878 -530.109)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.411,698.732c-.7.383-1.315.615-1.369.516s.475-.488,1.179-.871.424-.1.478,0S916.114,698.349,915.411,698.732Z",
    transform: "translate(-659.177 -532.091)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.213,687.74s-1.739,2.278.8,5.7,4.638,6.336,3.8,8.481c0,0-3.84-6.383-6.97-6.472S863.776,691.579,867.213,687.74Z",
    transform: "translate(-624.517 -524.957)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.2,687.74a2.8,2.8,0,0,0-.355.713c-3.047,3.583-4.673,6.925-1.742,7.008,2.728.079,6.019,4.958,6.786,6.19-.025.1-.057.187-.092.282,0,0-3.84-6.384-6.969-6.472S863.761,691.579,867.2,687.74Z",
    transform: "translate(-624.502 -524.957)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.43,695.793c0,.8.089,1.451.2,1.451s.2-.65.2-1.451-.114-.424-.225-.424S865.43,694.992,865.43,695.793Z",
    transform: "translate(-625.968 -530.109)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861,698.732c.7.383,1.318.615,1.372.516s-.476-.488-1.179-.871-.425-.1-.478,0S860.3,698.349,861,698.732Z",
    transform: "translate(-622.648 -532.091)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.18,725.918s4.866-.152,6.336-1.194,7.486-2.294,7.85-.634,7.311,8.328,1.818,8.373-12.763-.856-14.227-1.746S867.18,725.918,867.18,725.918Z",
    transform: "translate(-627.164 -549.241)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.286,737.564c-5.493.044-12.763-.855-14.227-1.746-1.115-.681-1.559-3.117-1.708-4.239h-.162s.317,3.922,1.771,4.815,8.734,1.79,14.227,1.746c1.584,0,2.135-.577,2.1-1.413C885.07,737.241,884.464,737.555,883.286,737.564Z",
    transform: "translate(-627.17 -554.909)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.275,724.558a3.717,3.717,0,0,0,1.216-1.834,1.643,1.643,0,0,0-.849-1.866c-.779-.3-1.612.244-2.246.789a2.992,2.992,0,0,1-2.18,1.052,3.317,3.317,0,0,0,1.026-3.108,1.3,1.3,0,0,0-.285-.634c-.434-.463-1.216-.266-1.736.1-1.647,1.159-2.107,3.4-2.116,5.411a10.17,10.17,0,0,1-.028-2.217,2.292,2.292,0,0,0-.836-1.974,2.534,2.534,0,0,0-1.267-.3,2.649,2.649,0,0,0-2.072.586,2.037,2.037,0,0,0,.082,2.534,8.2,8.2,0,0,0,2.141,1.717,4.753,4.753,0,0,1,1.533,1.461,1.818,1.818,0,0,1,.114.263h4.641A12.92,12.92,0,0,0,295.275,724.558Z",
    transform: "translate(-228.384 -546.1)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.467,648.954s-4.454-15.114.833-26.236a23.873,23.873,0,0,0,1.939-14.981,39.982,39.982,0,0,0-2.119-7.026",
    transform: "translate(-170.46 -465.498)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,571.5c0,1.853-3.352,7.226-3.352,7.226s-3.355-5.385-3.355-7.226a3.355,3.355,0,0,1,6.706,0Z",
    transform: "translate(-168.258 -443.317)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.621,599.9c-1,1.555-6.741,4.242-6.741,4.242s.1-6.336,1.112-7.888a3.355,3.355,0,0,1,5.629,3.646Z",
    transform: "translate(-180.139 -461.459)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.231,652.554c-1.654.833-7.961.257-7.961.257s3.288-5.414,4.942-6.247a3.355,3.355,0,1,1,3.019,5.991Z",
    transform: "translate(-176.989 -496.579)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.563,694.7c-1.489,1.1-7.8,1.584-7.8,1.584s2.325-5.889,3.8-6.992a3.355,3.355,0,1,1,3.988,5.385Z",
    transform: "translate(-170.492 -525.497)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.317,612.867c1.327,1.289,7.517,2.629,7.517,2.629s-1.517-6.149-2.851-7.442a3.355,3.355,0,1,0-4.673,4.812Z",
    transform: "translate(-162.615 -469.826)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.589,660.694c1.654.833,7.961.257,7.961.257s-3.288-5.411-4.942-6.247a3.354,3.354,0,1,0-3.019,5.991Z",
    transform: "translate(-153.4 -502.14)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,710.59c1.489,1.1,7.8,1.584,7.8,1.584s-2.322-5.889-3.8-6.992a3.355,3.355,0,0,0-3.988,5.386Z",
    transform: "translate(-151.856 -536.489)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,571.5c0,1.853-3.352,7.226-3.352,7.226s-3.355-5.385-3.355-7.226a3.355,3.355,0,0,1,6.706,0Z",
    transform: "translate(-168.258 -443.317)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.621,599.9c-1,1.555-6.741,4.242-6.741,4.242s.1-6.336,1.112-7.888a3.355,3.355,0,0,1,5.629,3.646Z",
    transform: "translate(-180.139 -461.459)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.231,652.554c-1.654.833-7.961.257-7.961.257s3.288-5.414,4.942-6.247a3.355,3.355,0,1,1,3.019,5.991Z",
    transform: "translate(-176.989 -496.579)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.563,694.7c-1.489,1.1-7.8,1.584-7.8,1.584s2.325-5.889,3.8-6.992a3.355,3.355,0,1,1,3.988,5.385Z",
    transform: "translate(-170.492 -525.497)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.317,612.867c1.327,1.289,7.517,2.629,7.517,2.629s-1.517-6.149-2.851-7.442a3.355,3.355,0,1,0-4.673,4.812Z",
    transform: "translate(-162.615 -469.826)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.589,660.694c1.654.833,7.961.257,7.961.257s-3.288-5.411-4.942-6.247a3.354,3.354,0,1,0-3.019,5.991Z",
    transform: "translate(-153.4 -502.14)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,710.59c1.489,1.1,7.8,1.584,7.8,1.584s-2.322-5.889-3.8-6.992a3.355,3.355,0,0,0-3.988,5.386Z",
    transform: "translate(-151.856 -536.489)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,738.6s5.423-1.077,6.868-2.512,7.951-3.947,8.674-2.154,9.757,7.895,3.611,8.972-14.455,1.435-16.261.716S171,738.6,171,738.6Z",
    transform: "translate(-151.526 -556.089)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.163,753.545c-6.143,1.077-14.455,1.435-16.261.719-1.375-.548-2.332-3.168-2.709-4.394l-.193.041s1.087,4.305,2.892,5.021,10.118.358,16.261-.716c1.774-.317,2.281-1.042,2.091-1.964C192.1,752.851,191.484,753.313,190.163,753.545Z",
    transform: "translate(-151.526 -567.405)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.421,365.344s-13.157,16.156-12.6,11.642c.348-2.835-1.451-6.3-2.851-8.487a26.253,26.253,0,0,0-1.511-2.154s8.028-14.715,8.474-12.71a16.369,16.369,0,0,0,2.265,3.748C580.718,360.861,584.421,365.344,584.421,365.344Z",
    transform: "translate(-422.392 -296.565)",
    fill: "#ffc1c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.7,787.982v1.584s-12.152-4.236-18.843-8.7c-2.759-1.84-3.545-3.551-3.393-4.919,3.694,1.869,10.565,5.433,12.646,7.039C641.875,784.351,646.443,786.509,649.7,787.982Z",
    transform: "translate(-463.373 -585.224)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.716,
    cy: 3.716,
    r: 3.716,
    transform: "translate(179.747 201.342)",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.716,
    cy: 3.716,
    r: 3.716,
    transform: "translate(141.789 196.125)",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.664,772.348a1.962,1.962,0,0,1-.219.757l-2.217,2.417-30.995-.5-8.335-.136s-17.544-3.193-20.962-4.682-16.856-4.214-16.856-4.214-8.116-1.362-9.307-5.3a3.406,3.406,0,0,1,.241-2.965,4.275,4.275,0,0,1,2.658-1.606,17.517,17.517,0,0,1,11.151.412L527.776,769.9l.8.206s18.52-.345,18.894-.279C550.316,770.346,550.73,771.553,550.664,772.348Z",
    transform: "translate(-350.037 -571.187)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.664,777.36c-3.117-.406-8.553-1-9.954-.428,0,0-9.887-1.223-23.49,3.1L508.9,779.9s-17.544-3.193-20.962-4.682-16.856-4.213-16.856-4.213-8.116-1.362-9.307-5.3a3.407,3.407,0,0,1,.241-2.965c.554,1.616,1.622,3.957,3.326,4.613,2.677,1.029,13.679,3.127,13.679,3.127l21.776,5.332s12.573,2.728,17.468.951a56.232,56.232,0,0,1,9.5-1.869l.8.206s18.52-.345,18.893-.279C550.316,775.358,550.73,776.565,550.664,777.36Z",
    transform: "translate(-350.037 -576.198)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.2,769.868a10.328,10.328,0,0,1-.174,1.391s-12.317.44-18.729-.51a4.733,4.733,0,0,1-3.269-1.508,2.316,2.316,0,0,1-.231-2.218,3.444,3.444,0,0,1,.269-.6c.478-.837,1.213-1.429,1.615-1.35,1.115.225,3.028-2.062,3.028-2.062-.152-1.4,2.044-1.9,2.386-1.673a.447.447,0,0,0,.713-.279c.022-.1.028-.608.028-1.2,0-.982-.028-2.218-.028-2.218l12.38,1.5.491,2.366c.45,2.11,1.077,5.008,1.346,6A7.165,7.165,0,0,1,599.2,769.868Z",
    transform: "translate(-428.648 -572.721)",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.092,794.7a10.308,10.308,0,0,1-.174,1.391s-12.317.44-18.729-.51a4.733,4.733,0,0,1-3.269-1.508,20.2,20.2,0,0,1,5.107.171C584.915,794.717,596.208,794.717,600.092,794.7Z",
    transform: "translate(-429.538 -597.556)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.6,758.244a.634.634,0,0,1-.269.6c-1.559,1.2-9.038-.1-9.038-.1s-15.282-.951-17.566-2.509a1.611,1.611,0,0,1-.5-.529c-.95-1.717,2.49-4.6,2.788-4.6s4.407-.561,4.682-.614c1.9-.384,3.8-1.562,4.118-1.226s1.9-.447,2.674-.557c.282-.041.412-.441.459-.95a10.565,10.565,0,0,0-.07-2.069l12.206,3.285.108,1.945.352,6.475.044.8A.275.275,0,0,1,518.6,758.244Z",
    transform: "translate(-370.193 -564.542)",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.69,780.338s-15.282-.95-17.566-2.509a1.608,1.608,0,0,1-.5-.529c3.1.253,8.256.681,9.187.919,1.34.317,8.87.779,8.87.779h9.26l.044.8C519.383,782.036,509.69,780.338,509.69,780.338Z",
    transform: "translate(-370.577 -586.146)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.716,
    cy: 3.716,
    r: 3.716,
    transform: "translate(123.181 196.125)",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.716,
    cy: 3.716,
    r: 3.716,
    transform: "translate(163.54 203.839)",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.888,432.83s-9.253.779-11.037,1.337-9.475.222-10.137,0-13.828,2.788-7.806,5.8,9.821,0,9.821,0,7.806-.447,9.82.783,9.364.557,9.364.557Z",
    transform: "translate(-351.936 -350.8)",
    fill: "#ffc1c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.82,319.043s5.354-2.651,5.129-3.111S630.82,319.043,630.82,319.043Z",
    transform: "translate(-465.68 -270.906)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.645,272.23s-2.218,1.448-1.559,2.8S717.645,272.23,717.645,272.23Z",
    transform: "translate(-523.851 -241.077)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.64,568.68s8.138,1.562,8.36,2.119S696.64,568.68,696.64,568.68Z",
    transform: "translate(-510.649 -443.614)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.79,585.57s4.346,2.677,4.457,3.456S705.79,585.57,705.79,585.57Z",
    transform: "translate(-516.9 -455.154)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.62,604.58s.668,3.01,1.784,3.457S702.62,604.58,702.62,604.58Z",
    transform: "translate(-514.734 -468.141)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.209,357.36c-.085.475-.738.529-.871.992-1.267,4.47-4.055,8.49-8.357,10.137a26.308,26.308,0,0,0-1.511-2.154s8.027-14.715,8.474-12.71A16.586,16.586,0,0,0,578.209,357.36Z",
    transform: "translate(-422.399 -296.558)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.636,324.365a14.664,14.664,0,1,1-4.3-10.421A14.719,14.719,0,0,1,538.636,324.365Z",
    transform: "translate(-382.588 -266.642)",
    fill: "#ffc1c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.116,749l.108,1.945c-1.289.285-3.741.659-5.17-.215-1.847-1.131-4.575-1.407-7.074-2.946a10.568,10.568,0,0,0-.07-2.069Z",
    transform: "translate(-402.203 -564.563)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.365,761.514c-.085.434-.165.7-.165.7s-9.836-1.007-12.672-2.366c0-.982-.028-2.218-.028-2.218l12.38,1.5Z",
    transform: "translate(-446.331 -572.707)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.93,593.33c-.669,1.784-1,2.12-.333,3.01s.333,5.575-.732,6.019-5.069,3.12-5.069,3.12,2.218,2.9,2.284,4.118a3.732,3.732,0,0,0,.862,2.119s3.434,7.359,4.118,9.7,1.311,6.019,1.311,6.019-1.2,3.345-.371,5.243,0,4.682,0,4.682-11.978-1.226-13.305-2.8-.443-5.116-.443-5.116a12.811,12.811,0,0,0-1.673-4.46c-1.34-2.119.317-4.346,0-4.461a9.423,9.423,0,0,1-2.347-3.342c-1.007-2.005-1.635-1.229-1.635-1.229s1.305,11.262,0,12.266-1.483.558-1.147,1.9a34.479,34.479,0,0,1,.557,3.9s-4.014,1.226-6.019,0-5.024-1.451-7.676-3.345,1.2-5.129,1.869-5.576-.222-6.912-.222-6.912l-.893-6.355s3.009.668,2.021-1.783-2.132-10.926-2.689-12.263,1.9-3.124,1.562-4.014,1.448-6.019,1.448-6.019.114-4.236,1.226-5.031a3.929,3.929,0,0,0,.884-2.246,27.873,27.873,0,0,0,.345-3.65s25.53-1.784,29.655.668c1.857,1.1,1.727,3.133.951,5.189a40.606,40.606,0,0,1-3.393,6C566.155,590.394,566.6,591.547,565.93,593.33Z",
    transform: "translate(-399.117 -448.754)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.6,582.686c-3.168.89-7.388,2.2-8.075,2.949-1.115,1.229-4.907-6.912-4.907-6.912s.225,6.12-4.793,3.561c-4.343-2.217-11.354-1.926-13.166-1.806a27.889,27.889,0,0,0,.345-3.649s25.53-1.784,29.655.668C584.516,578.6,584.386,580.631,583.6,582.686Z",
    transform: "translate(-412.28 -448.754)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.783,379.817s2.218-2.677,2.677-1.673,3.076,3.009,3.076,3.009.751,2.341,2.072,2.677,11.243,13.714,11.243,13.714l-3.57,7.245-2.9,17.617s.127,2.788-.662,3.8-3.8.78-2.4,2.005,3.4,2.341,4.517,7.92a51.861,51.861,0,0,0,2.452,8.807s-10.479,2.677-11.594,3.9-4.907-6.913-4.907-6.913.225,6.117-4.793,3.561-13.6-1.777-13.6-1.777v-6.589s1.673-2.566.783-4.349.608-5.129.608-5.129a26.262,26.262,0,0,0-1.391-5.461c-.893-2.005-.557-11.484-.557-11.484s-.678-6.133-.06-9.257a27.691,27.691,0,0,1,2.746-7.755c1.226-2.388,2-4.619,1.669-5.512s2.943-2.826,2.943-2.826l1.815,2.937.462,1.755S568.008,383.162,567.783,379.817Z",
    transform: "translate(-409.445 -313.284)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.712,432.83s6.244,6.13,6.912,7.134,2.908,6.225.01,7.809-14.255,4.026-15.383,3.184-7.92.95-7.92.95-11.36,2.788-8.908-1.784,8.252-3.8,8.252-3.8,9.371-.016,10.372-.95,8.553-2.94,6.843-7.071S604.712,432.83,604.712,432.83Z",
    transform: "translate(-430.328 -350.8)",
    fill: "#ffc1c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.658,519.41s-14.544,12.6-13.1,12.6S573.658,519.41,573.658,519.41Z",
    transform: "translate(-417.609 -409.953)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.451,535.6s-4.622,1.112-3.729,1.783S624.451,535.6,624.451,535.6Z",
    transform: "translate(-458.703 -421.014)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.29,439.16s5.769.516,4.752,2.322S581.29,439.16,581.29,439.16Z",
    transform: "translate(-431.84 -355.125)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.19,610.09s-.783,2.268,0,3.485,0,4.118,0,4.118V627.83s-.108,7.359,2.563,9.922Z",
    transform: "translate(-423.336 -471.906)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.83,709.81a19.067,19.067,0,0,1,1.784,3.12C547.839,713.767,545.83,709.81,545.83,709.81Z",
    transform: "translate(-407.614 -540.036)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.06,694.516s3.624-.669,4.182-.279S547.06,694.516,547.06,694.516Z",
    transform: "translate(-408.454 -529.313)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.147,738.49s-1.061.111,1.058,1.267,6.244,2.62,6.3,2.119S543.147,738.49,543.147,738.49Z",
    transform: "translate(-405.599 -559.63)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.69,703.356c.374,0,5.04-.279,4.771.447S592.69,703.356,592.69,703.356Z",
    transform: "translate(-439.629 -535.591)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.7,680.183s1.058-1.837,1.448-1.058S612.7,680.183,612.7,680.183Z",
    transform: "translate(-453.3 -518.94)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.643,324.315a14.659,14.659,0,0,1-.564,4.045,2.2,2.2,0,0,1-2.433.149,6.552,6.552,0,0,1-2.043-2.217,5.05,5.05,0,0,0-2.177-2.047,3.959,3.959,0,0,0-3.6.748c-1.039.748-1.869,1.736-2.851,2.534a4.638,4.638,0,0,1-3.485,1.248,5.985,5.985,0,0,1-2.218-1.02,19.9,19.9,0,0,0-3.013-1.933c-1.042-.4-1.9.317-2.892.317-.789.285-1.647.935-1.489,1.755a2.721,2.721,0,0,0,.405.849,3.564,3.564,0,0,1-.466,3.925,14.718,14.718,0,1,1,26.822-8.373Z",
    transform: "translate(-382.595 -266.593)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.145,313.195c-.789.285-1.647.935-1.492,1.758a2.818,2.818,0,0,0,.409.846,3.556,3.556,0,0,1-1.584,4.787,1.4,1.4,0,0,1-.881.139,1.557,1.557,0,0,1-.634-.38,5.863,5.863,0,0,1-1.828-3.152,38.021,38.021,0,0,1-.244-3.912c-.139-1.3-.586-2.585-.741-3.9a3.616,3.616,0,0,1,.2-1.926,4.485,4.485,0,0,1,.8-1.1,10.29,10.29,0,0,0,2.265-3.263c.706-2,.193-4.552,1.739-6.019a9.665,9.665,0,0,1,2.6-1.346,18.325,18.325,0,0,0,2.392-1.518c2.867-1.97,6.352-3.485,9.76-2.788a13.888,13.888,0,0,1,3.868,1.584,43.51,43.51,0,0,1,6.336,4.258,9.865,9.865,0,0,1,2.218,2.278,7.9,7.9,0,0,1,.969,2.423,13.887,13.887,0,0,1,.184,5.7c-.317,1.856-1.036,3.659-1.064,5.544a3.583,3.583,0,0,1-.276,1.863,2.065,2.065,0,0,1-2.705.469,6.457,6.457,0,0,1-2.04-2.218,5.007,5.007,0,0,0-2.176-2.043,3.957,3.957,0,0,0-3.6.745c-1.039.744-1.866,1.736-2.851,2.534a4.62,4.62,0,0,1-3.485,1.248,5.976,5.976,0,0,1-2.218-1.017,19.544,19.544,0,0,0-3.009-1.932C509.024,312.466,508.134,313.195,507.145,313.195Z",
    transform: "translate(-376.37 -254.075)",
    fill: "#794f6a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamifySelfLearning);
export default __webpack_public_path__ + "static/media/gamify_Self_Learning.eb8fdc5cffbaf81b7b756019ee2722e1.svg";
export { ForwardRef as ReactComponent };